import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'
import bus from '../utils/js/bus';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/education',
    name: 'Education',
    component: () => import(/* webpackChunkName: "education" */ '../views/Education')
  },
  {
    path: '/feature',
    name: 'Feature',
    component: () => import(/* webpackChunkName: "feature" */ '../views/Feature')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import(/* webpackChunkName: "download" */ '../views/Download')
  },
  {
    path: '/main',
    name: 'Whiteboard',
    beforeEnter(to, from, next) {
      window.location.href = window.location.origin + '/main';
    },
  },
  {
    path: '/eula',
    name: 'EULA',
    beforeEnter(to, from, next) {
      window.location.href = window.location.origin + '/main/#/eula';
    },
  },
  {
    path: '/policy',
    name: 'Policy',
    beforeEnter(to, from, next) {
      window.location.href = window.location.origin + '/main/#/policy';
    },
  },
]

const router = new VueRouter({
	scrollBehavior(from, to, savePosition){
		return {y:0};
	},
  routes
})

router.beforeEach((to, from, next)=>{
	bus.$emit('showNav', false);

  if (to.path!=from.path) {
    bus.$emit('showLoading', true);
    setTimeout(next, 400);
  } else next();

})


export default router
